import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ExternalLink, AlertTriangle } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { Button } from '../components/ui/Button';
export function HelpShopifyPage() {
  return <div className="min-h-screen bg-gray-50" dir="rtl" data-id="element-1956">
      <Navbar data-id="element-1957" />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1958">
        <Link to="/configure" className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-6" data-id="element-1959">
          <ArrowRight className="ml-2 w-4 h-4" data-id="element-1960" />
          رجوع إلى الإعدادات
        </Link>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-1961">
          <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-green-50 to-emerald-50" data-id="element-1962">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-1963">
              كيفية ربط Shopify
            </h1>
            <p className="text-gray-600" data-id="element-1964">
              اتبع الخطوات التالية للحصول على Admin API Access Token من متجر
              Shopify
            </p>
          </div>

          <div className="p-8 space-y-8" data-id="element-1965">
            {/* Warning */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 flex items-start gap-3" data-id="element-1966">
              <AlertTriangle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" data-id="element-1967" />
              <div className="text-sm text-yellow-800" data-id="element-1968">
                <strong data-id="element-1969">تحذير أمني:</strong> لا تشارك Admin API Access Token مع
                أي شخص. احتفظ به في مكان آمن.
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-6" data-id="element-1970">
              <div className="flex gap-4" data-id="element-1971">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1972">
                  1
                </div>
                <div className="flex-1" data-id="element-1973">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1974">
                    افتح Shopify Admin
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1975">
                    سجل دخولك إلى لوحة تحكم Shopify الخاصة بمتجرك
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1976">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1977">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1978">
                  2
                </div>
                <div className="flex-1" data-id="element-1979">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1980">
                    اذهب إلى Apps and sales channels
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1981">
                    من القائمة الجانبية، اختر "Settings" → "Apps and sales
                    channels"
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1982">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1983">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1984">
                  3
                </div>
                <div className="flex-1" data-id="element-1985">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1986">
                    أنشئ Custom App
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1987">
                    اضغط على "Develop apps" → "Create an app" → أدخل اسم التطبيق
                    (مثلاً: Operiens Integration)
                  </p>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1988">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1989">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-1990">
                  4
                </div>
                <div className="flex-1" data-id="element-1991">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-1992">
                    اضبط الصلاحيات (Scopes)
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-1993">
                    اذهب إلى "Configure Admin API scopes" واختر الصلاحيات
                    المطلوبة:
                  </p>
                  <ul className="list-disc list-inside text-gray-600 space-y-1 mb-3" data-id="element-1994">
                    <li data-id="element-1995">read_products, write_products</li>
                    <li data-id="element-1996">read_orders, write_orders</li>
                    <li data-id="element-1997">read_customers, write_customers</li>
                  </ul>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-1998">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-1999">
                <div className="flex-shrink-0 w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-bold" data-id="element-2000">
                  5
                </div>
                <div className="flex-1" data-id="element-2001">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-2002">
                    احصل على Admin API Access Token
                  </h3>
                  <p className="text-gray-600 mb-3" data-id="element-2003">
                    اضغط على "Install app" → انسخ "Admin API access token"
                    والصقه في صفحة الإعدادات
                  </p>
                  <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700 mb-3" data-id="element-2004">
                    ⚠️ هذا الـ Token سيظهر مرة واحدة فقط. احفظه في مكان آمن.
                  </div>
                  <div className="bg-gray-100 rounded-lg p-4 text-center text-gray-500" data-id="element-2005">
                    [صورة توضيحية - سيتم إضافتها]
                  </div>
                </div>
              </div>
            </div>

            {/* Video Tutorial */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2006">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-2007">شرح بالفيديو</h3>
              <div className="bg-gray-100 rounded-lg aspect-video flex items-center justify-center text-gray-500" data-id="element-2008">
                [فيديو يوتيوب - سيتم إضافته]
              </div>
            </div>

            {/* CTA */}
            <div className="border-t border-gray-100 pt-8" data-id="element-2009">
              <Link to="/configure" data-id="element-2010">
                <Button size="lg" fullWidth data-id="element-2011">
                  رجوع إلى الإعدادات
                  <ArrowRight className="mr-2 w-5 h-5" data-id="element-2012" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>;
}